import { defineStore } from "pinia";

export const useUiStore = defineStore("uiStore", {
  state: () => ({
    routes: []
  }),
  actions: {
    getRouteByName(name) {
      return this.routes.find(r => r.name === name);
    }
  },
});
